import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  Flex,
  useDisclosure,
  Icon,
} from '@wegroup/design-system';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router';
import { RootState } from '../../store/redux/reducers/rootReducer';

const ToolbarBackToDashboardButton: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const cancelRef = useRef<HTMLButtonElement>(null);

  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleOnClick = () => {
    history.push(`/dashboard`);
    onClose();
  };

  const sessionActive = useSelector(
    (state: RootState) => state.productFactory.sessionActive,
  );

  return (
    <>
      <Flex
        mt={{ base: '2', laptopL: '8' }}
        cursor="pointer"
        sx={{ svg: { w: '7', h: '7' } }}
      >
        <Button
          leftIcon={<Icon name="IconChevronLeftRounded" color="white" />}
          variant="link"
          color="white"
          onClick={() =>
            sessionActive ? onOpen() : history.push(`/dashboard`)
          }
        >
          {t('Return to dashboard')}
        </Button>
      </Flex>
      <AlertDialog
        motionPreset="slideInBottom"
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader textStyle="largeBodyBold">
              {t('Go back?')}
            </AlertDialogHeader>

            <AlertDialogBody>
              {location.pathname.match(
                new RegExp('/product/session/(offers).*'),
              )
                ? t(
                    'Are you sure you want to go back? You will lose any changes made to the offers and no offers will remain selected',
                  )
                : t(
                    'Are you sure you want to go back? All session data is saved and can be retrieved trough conversation history',
                  )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} variant="grayedGhost" onClick={onClose}>
                {t('Cancel')}
              </Button>
              <Button onClick={handleOnClick} ml={3}>
                {t('Go back')}
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default ToolbarBackToDashboardButton;
